import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <SEOHead
        title="Privacy Policy — Dhivisha Architects"
        description="Privacy Policy for Dhivisha Architects. Learn how we collect, use, and protect your personal information."
        path="/privacy-policy"
      />
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">Privacy Policy</h1>
            <p className="text-sm text-muted-foreground mb-10">Last updated: March 27, 2026</p>

            <div className="prose prose-sm max-w-none space-y-8 text-muted-foreground">
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">1. Information We Collect</h2>
                <p>When you contact us or use our services, we may collect the following information:</p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>Name, email address, and phone number</li>
                  <li>Project requirements and property details</li>
                  <li>Communication records and correspondence</li>
                  <li>Website usage data through cookies and analytics</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">2. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>Respond to your inquiries and provide architectural services</li>
                  <li>Communicate project updates and relevant information</li>
                  <li>Improve our website and services</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">3. Information Sharing</h2>
                <p>
                  We do not sell, trade, or rent your personal information to third parties. We may share your information only with trusted partners who assist us in operating our website or conducting our business, and only when those parties agree to keep this information confidential.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">4. Data Security</h2>
                <p>
                  We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">5. Cookies</h2>
                <p>
                  Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings, though this may affect some features of the website.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">6. Third-Party Links</h2>
                <p>
                  Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to read the privacy policies of any linked websites.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">7. Your Rights</h2>
                <p>You have the right to:</p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>Request access to your personal data</li>
                  <li>Request correction or deletion of your data</li>
                  <li>Withdraw consent for data processing</li>
                  <li>Lodge a complaint with a data protection authority</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">8. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                <div className="mt-2">
                  <p><strong className="text-foreground">Dhivisha Architects</strong></p>
                  <p>No:9, Needamangalam Rd, Elanga Nagar, Srinivas Nagar, Sakkottai, Kumbakonam, Tamil Nadu 612001</p>
                  <p>Email: mail@dhivishaarchitects.com</p>
                  <p>Phone: +91 99948 49332 / +91 84280 77535</p>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;
